import { apiSlice } from '@/store/api/apiSlice';

export interface PratyantarDasha {
    planet: string;
    planet_id: number;
    start: string;
    end: string;
}

export interface PratyantarDashaArgs {
    userId: string;
    mahaDasha: string;
    antraDasha: string;
}

export const pratyantarDashaApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getPratyantarDasha: builder.query<PratyantarDasha[], PratyantarDashaArgs>({
            query: ({ userId, mahaDasha, antraDasha }) => ({
                url: 'astrology/pratyantar-dasha',
                method: 'GET',
                params: {
                    userId,
                    mahaDasha,
                    antraDasha,
                },
            }),
        }),
    }),
});

export const { useLazyGetPratyantarDashaQuery, useGetPratyantarDashaQuery } = pratyantarDashaApi;
